var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-10 offset-md-1"},[_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_vm._v("\n      "+_vm._s(_vm.headline)+"\n    ")])],1),_vm._v(" "),_c('upload',{ref:"upload",attrs:{"multiple":true,"showSubmitButton":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bce09fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_deals/actions/AdditionalFilesForm.vue
// module id = null
// module chunks = 